import * as t from 'io-ts';
import { nonEmptyString, stringEnum } from '../utils';

enum LogLevel {
  TRACE = 'TRACE',
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  WARN = 'WARN',
}

const Fluentd = t.exact(t.interface({
  endpoint: nonEmptyString,
  globalLogLevel: stringEnum<LogLevel>(LogLevel, 'LogLevel'),
  disabled: t.boolean,
}), 'Fluentd');

export type IFluentd = t.TypeOf<typeof Fluentd>;

export default Fluentd;
